// ISDP CUSTOM: Shared toast context + hook.
//
// Lives in isdp-common (not packages/app) so BOTH the app AND app-facing plugins
// (e.g. the admin plugin, which can't import from packages/app) resolve the SAME
// React context instance — and therefore share the single ToastProvider the app
// mounts at its root. The provider's rendering/CSS/i18n stays in packages/app; only
// the context + hook + type are shared here.
import { createContext, useContext } from 'react';

export interface ToastApi {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

/** Access the toast API. Safe no-op fallback when used outside the provider. */
export const useToast = (): ToastApi => {
  const ctx = useContext(ToastContext);
  return (
    ctx ?? {
      success: () => {},
      error: () => {},
      info: () => {},
    }
  );
};
